// Re-enable un-changed fields; used after submit

export default function() {

    $('.data-collection-content input.temp, .data-collection-content select.temp, .data-collection-content textarea.temp').attr('disabled', false).removeClass('temp');

    $('.survey-card-body[data-val-changed=\'true\']').attr('data-val-changed', 'false');

}